<template lang="pug">
  .fighters__preloader
    img(src="@/assets/img/global/loader.gif" alt="")
</template>

<script>
export default {
  name: 'FightersPreloader'
}
</script>
